import React from "react";
import "./AdminAuthLayout.css";

const AdminAuthLayout = () => {
  return <div className="adminAuthLayout">Loading...</div>;
};

export default AdminAuthLayout;
